import axios from '../utils/axios';

export default function postDomainMapping(adminId, data) {
    return (
        axios.post('/admin/' + adminId + '/domain-mapping',  data )
    )
}
